import React from "react";
import Aos from "aos";
import { useEffect } from "react";

import "aos/dist/aos.css";
const Consultenen = () => {
	useEffect(() => {
		Aos.init({ duration: 1000 });
	});
	return (
		<div
			className="h-screen overflow-x-hidden flex justify-center items-center bg-cover bg-center relative"
			style={{
				backgroundImage:
					`url("/assets/consult.jpeg")`,
			}}>
			<div className="absolute inset-0 bg-black bg-opacity-50 flex flex-col items-center justify-center">
				<div data-aos="fade-down" className="text-center text-white ">
					<h1 className="text-6xl  font-custom font-bold mb-4">
						Get a Personal Consultation
					</h1>
					<p className="text-[17px] sm:text-2xl mb-8">
						Personalized Guidance for Your Legal Needs
					</p>

					<button className="font-bold px-24 py-3  text-white bg-[#001C38] hover:bg-white hover:text-black transition-all duration-300">
						<a href="/en/consultation">
							Contact Us
						</a>

					</button>
				</div>
			</div>
		</div>
	);
};

export default Consultenen;
